/*
 * Copyright (c) 2016-2017 VMware, Inc. All Rights Reserved.
 * This software is released under MIT license.
 * The full license information can be found in LICENSE in the root directory of this project.
 */

import {Injectable, Optional, SkipSelf} from '@angular/core';
import {Observable} from 'rxjs/Observable';
import {Subject} from 'rxjs/Subject';
export class RootDropdownService {
private _changes: Subject<boolean> = new Subject<boolean>();
/**
 * @return {?}
 */
get changes(): Observable<boolean> {
        return this._changes.asObservable();
    }
/**
 * @return {?}
 */
closeMenus(): void {
        this._changes.next(false);
    }
static decorators: DecoratorInvocation[] = [
{ type: Injectable },
];
/**
 * @nocollapse
 */
static ctorParameters: () => ({type: any, decorators?: DecoratorInvocation[]}|null)[] = () => [
];
}

function RootDropdownService_tsickle_Closure_declarations() {
/** @type {?} */
RootDropdownService.decorators;
/**
 * @nocollapse
 * @type {?}
 */
RootDropdownService.ctorParameters;
/** @type {?} */
RootDropdownService.prototype._changes;
}

/**
 * @param {?} existing
 * @return {?}
 */
export function clrRootDropdownFactory(existing: RootDropdownService) {
    return existing || new RootDropdownService();
}

export const /** @type {?} */ ROOT_DROPDOWN_PROVIDER = {
    provide: RootDropdownService,
    useFactory: clrRootDropdownFactory,
    deps: [[new Optional(), new SkipSelf(), RootDropdownService]]
};

interface DecoratorInvocation {
  type: Function;
  args?: any[];
}
